export const environment = {
  production: false,
  baseUrl: 'https://gest-inf-api.int-dev2.goproject.it/api',
  testBaseUrl: 'http://localhost:3000'
};
